// JavaScript for maintaining Newsletter signup
const newsletter = (function (window, jQuery) {
	"use strict";

	if (!jQuery) {
		console.log('Newsletter requires jQuery. Make sure it is referenced.');
		return;
	}

	jQuery('.czt-newsletter form').on('submit', function (e) {

		let $form = jQuery(this);
		let messageId = $form.data('message-id');

		let result = validateCheckboxes($form, messageId);

		if (!result) {
			e.preventDefault();
		}
	});

	jQuery('.czt-newsletter .btn-newsletter-signup').on('click', function (e) {
		e.preventDefault();

		let $this = jQuery(this);
		let $emailInput = $this.siblings('input[type="email"]');
		let modalId = $this.data('modal-id');
		let messageId = $this.data('message-id');

		validateEmail($emailInput, modalId, messageId);
	});

	jQuery('.czt-newsletter .news-check .check-input').on('click', function (e) {
		let $input = jQuery(this);
		let $parent = $input.parent('.news-check');

		if ($input.is(':checked')) {
			$parent.addClass('checked');
		}
		else {
			$parent.removeClass('checked');
		}
	});

	function validateEmail($emailInput, modalId, messageId) {
		let emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

		let isValid = $emailInput.val().length > 0 || emailRegExp.test($emailInput.val());

		if (isValid) {
			jQuery('#' + messageId).hide();

			jQuery('#' + modalId).modal();
		}
		else {
			jQuery('#' + messageId).show();
		}
	};

	function validateCheckboxes($form, messageId) {
		let $checkedCheckboxes = $form.find('.news-check .check-input:checked');

		if ($checkedCheckboxes.length > 0) {
			jQuery('#' + messageId).hide();
			return true;
		}
		else {
			jQuery('#' + messageId).show();
			return false;
		}
	}

})(window, jQuery);

export default newsletter;
